<div class="jk-row-border" style="width: 360px;">
  <h1 class="text-center text-blue-700">泡茶計時器</h1>
  <div class="text-center text-yellow-300 bg-black bg-clip-border w-full text-4xl" >{{second}}</div>

  <table class="w-full">
    <tr>
      <td class="jk-column2">
        <button class="btn-primary w-full h-12" (click)="resetTimer()"  color="danger">
          <mat-icon >clear_all</mat-icon>
          <mat-label>歸零</mat-label>
        </button>
      </td>
      <td class="jk-column2">
        <app-jkcheckbox label="使用azure語音"  [(value)]="isAzureSpeech" >
        </app-jkcheckbox>

        <button class="btn-primary w-full h-12"  (click)="showVoices()" [textContent]="'測試'">
          測試
        </button>

      </td>
    </tr>
    <tr>
      <!-- style="width:100px;border: 1px solid #888;height: 400px;" -->
      <td class="jk-column2">
        <button class="btn-primary w-full h-12" (click)="startTimer(30)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>30秒</mat-label>
        </button>

      </td>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(80)"  color="primary" [disabled]="buttonDisabled">
          <mat-label>80秒</mat-label>
        </button>
      </td>
    </tr>
    <tr>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(40)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>40秒</mat-label>
        </button>
      </td>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(90)"  color="primary" [disabled]="buttonDisabled">
          <mat-label>90秒</mat-label>
        </button>
      </td>
    </tr>
    <tr>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(50)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>50秒</mat-label>
        </button>
      </td>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(100)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>100秒</mat-label>
        </button>
      </td>
    </tr>
    <tr>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(60)"  color="secondary" [disabled]="buttonDisabled">

          <mat-label>60秒</mat-label>
        </button>
      </td>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(110)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>110秒</mat-label>
        </button>
      </td>
    </tr>
    <tr>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(70)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>70秒</mat-label>
        </button>
      </td>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(120)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>120秒</mat-label>
        </button>
      </td>
    </tr>
    <tr>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(150)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>150秒/兩分半</mat-label>
        </button>
      </td>
      <td class="jk-column2" >
        <button class="btn-primary w-full h-12"  (click)="startTimer(180)"  color="primary" [disabled]="buttonDisabled">

          <mat-label>180秒/三分</mat-label>
        </button>
      </td>
    </tr>
  </table>
</div>
